import { GridConfig } from '../models/grid-config.model';

export class GridConfigChange {
  static readonly type = '[ColumnConfigurator] GridConfigChange';
  constructor(public gridConfig: GridConfig) {}
}
